import React from 'react';
import { Box, Typography } from '@mui/material';
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import type { TrendSignalSnapshot } from '../types';
import { DISPLAY_FONT, TREND_CHART_COLORS, TREND_COLORS } from '../trendTheme';

type TrendHistoryChartProps = {
  title: string;
  snapshots: TrendSignalSnapshot[];
};

export default function TrendHistoryChart({ title, snapshots }: TrendHistoryChartProps) {
  if (snapshots.length === 0) {
    return (
      <Box sx={{ p: 3, border: `1px dashed ${TREND_COLORS.divider}`, borderRadius: 2, bgcolor: TREND_COLORS.cardBg }}>
        <Typography sx={{ fontFamily: DISPLAY_FONT, color: TREND_COLORS.navy }}>{title}</Typography>
        <Typography variant="body2" sx={{ color: TREND_COLORS.textMuted }}>
          Ingen historik tillgänglig ännu.
        </Typography>
      </Box>
    );
  }

  const data = snapshots.map((snapshot) => ({
    issueDate: snapshot.issueDate.slice(0, 10),
    strengthScore: snapshot.strengthScore,
    momentumScore: snapshot.momentumScore,
  }));

  return (
    <Box sx={{ width: '100%', height: 300, p: 2, border: `1px solid ${TREND_COLORS.divider}`, borderRadius: 2, bgcolor: TREND_COLORS.cardBg }}>
      <Typography sx={{ fontFamily: DISPLAY_FONT, color: TREND_COLORS.navy, mb: 1 }}>
        {title}
      </Typography>
      <ResponsiveContainer width="100%" height="90%">
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke={TREND_CHART_COLORS.grid} />
          <XAxis dataKey="issueDate" stroke={TREND_COLORS.textMuted} />
          <YAxis stroke={TREND_COLORS.textMuted} />
          <Tooltip />
          <Line type="monotone" dataKey="strengthScore" stroke={TREND_CHART_COLORS.primary} strokeWidth={2} />
          <Line type="monotone" dataKey="momentumScore" stroke={TREND_CHART_COLORS.secondary} strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
}
